import React, { useEffect, useRef, useState } from 'react';

// A partir de quantos pixels rolados o botão aparece
const DISTANCIA_PARA_APARECER = 300;
// Distância do canto inferior direito do formulário (deixa espaço para a barra de rolagem)
const MARGEM_DIREITA = 22;
const MARGEM_INFERIOR = 16;

/**
 * Bolinha laranja com seta para cima no canto inferior direito DO FORMULÁRIO, ao lado da barra de rolagem dele.
 * Aparece só depois de rolar o formulário para baixo; ao clicar, volta ao topo.
 * Funciona com o formulário dentro de um pop-up com rolagem própria ou com a página rolando:
 * escuta a rolagem de qualquer elemento e usa o que contém este componente.
 */
function BotaoVoltarTopo() {
  const ancoraRef = useRef(null);
  const containerRef = useRef(null); // elemento que está rolando (null = a página)
  const [visivel, setVisivel] = useState(false);
  const [posicao, setPosicao] = useState({ right: MARGEM_DIREITA, bottom: MARGEM_INFERIOR });

  // Canto inferior direito da área visível do formulário, em coordenadas da tela
  const calcularPosicao = () => {
    const container = containerRef.current;
    const referencia = container || ancoraRef.current?.parentElement;
    if (!referencia) return;

    const area = referencia.getBoundingClientRect();
    const fundoVisivel = Math.min(area.bottom, window.innerHeight);
    setPosicao({
      right: Math.max(8, window.innerWidth - area.right + MARGEM_DIREITA),
      bottom: Math.max(8, window.innerHeight - fundoVisivel + MARGEM_INFERIOR)
    });
  };

  useEffect(() => {
    const aoRolar = (evento) => {
      const ancora = ancoraRef.current;
      if (!ancora) return;

      const alvo = evento.target;
      let rolado;
      if (alvo === document || alvo === document.documentElement || alvo === document.body) {
        containerRef.current = null;
        rolado = window.scrollY || document.documentElement.scrollTop;
      } else if (alvo instanceof Element && alvo.contains(ancora)) {
        containerRef.current = alvo;
        rolado = alvo.scrollTop;
      } else {
        return; // rolagem de outra parte da tela (ex.: uma lista interna)
      }

      setVisivel(rolado > DISTANCIA_PARA_APARECER);
      calcularPosicao();
    };

    // capture: true recebe a rolagem de qualquer elemento, não só da janela
    document.addEventListener('scroll', aoRolar, true);
    window.addEventListener('resize', calcularPosicao);
    return () => {
      document.removeEventListener('scroll', aoRolar, true);
      window.removeEventListener('resize', calcularPosicao);
    };
  }, []);

  const voltarAoTopo = () => {
    const container = containerRef.current;
    if (container) container.scrollTo({ top: 0, behavior: 'smooth' });
    else window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <span ref={ancoraRef} style={{ display: 'none' }} />
      {visivel && (
        <button
          type="button"
          className="botao-voltar-topo"
          onClick={voltarAoTopo}
          aria-label="Voltar ao topo"
          title="Voltar ao topo"
          style={{ right: posicao.right, bottom: posicao.bottom }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 19V5M5 12l7-7 7 7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}
      <style>{`
        .botao-voltar-topo {
          position: fixed;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: none;
          background-color: rgb(235, 133, 0);
          box-shadow: 0 4px 15px rgba(235, 133, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 999997;
          transition: background-color 0.2s ease;
        }
        .botao-voltar-topo:hover {
          background-color: rgb(210, 115, 0);
        }
      `}</style>
    </>
  );
}

export default BotaoVoltarTopo;
